import { useMemo } from 'react';

import { GridColDef } from '@mui/x-data-grid-pro';

import { formatUSD } from 'src/shared/utils/format-usd';

import { BrandNameAndImageCell } from '../shared/components';
import { BrandRow } from '../shared/types';

import { ConnectionStatusCell, ConnectionStatusHeader } from './components';

export const useColumns = () => {
  return useMemo(
    (): GridColDef<BrandRow>[] => [
      {
        field: 'name',
        headerName: 'Brand',
        flex: 1,
        renderCell: BrandNameAndImageCell,
      },
      {
        field: 'connectionStatus',
        headerName: 'Brand Connection Status',
        flex: 1,
        renderCell: ConnectionStatusCell,
        renderHeader: ConnectionStatusHeader,
      },
      {
        align: 'right',
        headerAlign: 'right',
        field: 'grossMerchandiseValue',
        headerName: 'Gross Merchandise Value',
        flex: 1,
        valueFormatter: formatUSD,
      },
    ],
    [],
  );
};
